<template>
    <div>
        <div class="product-detail__pricing" uk-grid data-uk-grid-margin="{cls: 'uk-margin-top'}" v-if="variant && variant.pricing">
            <div class="uk-width-expand">
                <span class="product-detail__price uk-text-large">{{ Utils.Currencies.toHuman(variant.pricing.price*quantity) }}</span>
                <span class="product-detail__discounted-price uk-text-muted" v-if="variant.pricing.reduced">
                    <del>{{ Utils.Currencies.toHuman(variant.pricing.original_price*quantity) }}</del>
                </span>
            </div>
            <div class="uk-width-auto">
                <a class="product-detail__availability uk-text-small uk-text-success" title="lorem ipsum dolor sit amet" uk-tooltip>
                   <i class="fal fa-check-circle"></i>
                    {{ $t('rubinred.ecommerce.products.common.available') }}
                </a>
            </div>
        </div>
        <div class="uk-grid uk-flex-middle" data-uk-grid-margin="{cls: 'uk-margin-top'}" v-else>
            <div class="uk-width-large-1-2 uk-text-right uk-text-left-medium">
                <div class="product-detail__availability uk-text-danger">
                    <span class="fal fa-check-circle"></span>
                    {{ $t('rubinred.ecommerce.products.common.unavailable') }}
                </div>
            </div>
        </div>

        <div class="product-detail__button-wrapper uk-grid-small" uk-grid>
            <div class="uk-width-5-6@m">
                <a class="product-detail__button uk-button uk-button-primary uk-width-1-1" @click="addToCart()">
                    {{ $t('rubinred.ecommerce.core.action.add_cart') }}
                    <i class="fal fa-shopping-cart"></i>
                </a>
            </div>
            <div class="uk-width-1-6@m">
                <slot name="additional-button"></slot>
            </div>
        </div>
    </div>
</template>
<script>
  export default {
    props: {
      selectedVariant: {
        type: Object,
        default: null,
      },
      cartEndpoint: {
        type: String,
        required: true,
      }
    },
    data() {
      return {
        variant: this.selectedVariant,
        quantity: 1,
      };
    },
    mounted() {
      window.App.$on('variant-changed', variant => {
        this.variant = variant;
      });
      window.App.$on('quantity-changed', (quantity, vm) => {
        this.quantity = quantity;
      });
    },
    methods: {
      addToCart() {
        this.$store.dispatch('cart/add', {variant_id: this.variant.id, quantity: this.quantity}).then(({data}) => {
            if(data.success) {
              window.location.href = this.cartEndpoint;
            }
        });
      }
    }
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/taxonomies/assets/js/components/ProductSubmit.vue